var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecruiterRole(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1748 31.9901L32.0028 29.1631L44.0218 41.1821L41.1938 44.0091L29.1748 31.9901Z",
    fill: "#616161"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 36C28.8366 36 36 28.8366 36 20C36 11.1634 28.8366 4 20 4C11.1634 4 4 11.1634 4 20C4 28.8366 11.1634 36 20 36Z",
    fill: "#616161"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4502 35.3397L35.2772 32.5117L43.9732 41.2077L41.1452 44.0357L32.4502 35.3397Z",
    fill: "#37474F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 33C27.1797 33 33 27.1797 33 20C33 12.8203 27.1797 7 20 7C12.8203 7 7 12.8203 7 20C7 27.1797 12.8203 33 20 33Z",
    fill: "#64B5F6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9003 14.2C25.2003 12.2 22.7003 11 20.0003 11C17.3003 11 14.8003 12.2 13.1003 14.2C12.7003 14.6 12.8003 15.3 13.2003 15.6C13.6003 16 14.3003 15.9 14.6003 15.5C16.0003 13.9 17.9003 13 20.0003 13C22.1003 13 24.0003 13.9 25.4003 15.5C25.6003 15.7 25.9003 15.9 26.2003 15.9C26.4003 15.9 26.7003 15.8 26.8003 15.7C27.2003 15.3 27.2003 14.6 26.9003 14.2Z",
    fill: "#BBDEFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruiterRole);
export default __webpack_public_path__ + "static/media/recruiter-role.78fb0afdabb40fb7f98c86035c41a4d3.svg";
export { ForwardRef as ReactComponent };